import { Box } from "@mui/material";
import * as React from "react";
import NewsLetterSubscribersList from "./NewsLetterSubscribersList";

export default function NewsLetterSubscribers() {
  return (
    <Box sx={{ width: "100%" }} className="container container-h-full">
      <Box>
        <div className="content-subheader">
          <h2 className="font-weight-bolder">News Letter Subscribers List</h2>
        </div>
      </Box>
      <div className="sub-content-sec recently-blog">
        <NewsLetterSubscribersList />
      </div>
    </Box>
  );
}
